import { IMenuItem } from 'src/app/layout/navigation/models/nav-item.model';
import { ADMIN_CLAIMS, EClaimsGroup } from '../claims.config';
import {
  ADMIN_ACCOUNT_ROUTES,
  ADMIN_ACE_ROUTES,
  ADMIN_INTEGRATION_ROUTES,
  ADMIN_ROOT_ROUTES,
  ADMIN_WORK_ORDERS_ROUTES,
  ROOT_ROUTES,
} from '../router.config';

export const ADMIN_NAVIGATION_CONFIG: IMenuItem[] = [
  {
    label: 'Account',
    expanded: true,
    claimGroupName: EClaimsGroup.account,
    items: [
      {
        label: 'Sites',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.account}/${ADMIN_ACCOUNT_ROUTES.sites}`,
        claimName: ADMIN_CLAIMS.AccountSiteRead,
      },
      {
        label: 'User Management',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.account}/${ADMIN_ACCOUNT_ROUTES.userManagement}`,
        claimName: ADMIN_CLAIMS.AccountUserManagementRead,
      },
    ],
  },
  {
    label: 'Fenix AI',
    expanded: true,
    claimGroupName: EClaimsGroup.aceAi,
    items: [
      {
        label: 'General',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.general}`,
        claimName: ADMIN_CLAIMS.aceAiGeneralRead,
      },
      {
        label: 'Pricing and Availability',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.pricingAndAvailability}`,
        claimName: ADMIN_CLAIMS.aceAiPricingAvailabilityRead,
      },
      {
        label: 'Tour Options',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.tourOptions}`,
        claimName: ADMIN_CLAIMS.aceAiScheduleTourRead,
      },
      {
        label: 'Leasing Questions',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.leasingQuestions}`,
        claimName: ADMIN_CLAIMS.aceAiLeasingQuestionsRead,
      },
      {
        label: 'Resident Questions',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.residentQuestions}`,
        claimName: ADMIN_CLAIMS.aceAiResidentQuestionsRead,
      },
      {
        label: 'Chatbot Style',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.chatbotStyle}`,
        claimName: ADMIN_CLAIMS.aceAiChatbotRead,
      },
      {
        label: 'Chatbot Sandbox',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.chatbotSandbox}`,
        claimName: ADMIN_CLAIMS.aceAiChatbotSandboxRead,
      },
      {
        label: 'Rules',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.aceRules}`,
        claimName: ADMIN_CLAIMS.aceAiRulesRead,
      },
      {
        label: 'Work Orders',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.workOrders}`,
        claimName: ADMIN_CLAIMS.aceAiGeneralRead,
      },
      {
        label: 'Property Variables',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.propertyVariables}`,
        claimName: ADMIN_CLAIMS.AceAiPropertyVariablesRead,
      },
      {
        label: 'System Prompts',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.systemPrompts}`,
        claimName: ADMIN_CLAIMS.aceAiSystemResponsesRead,
      },
      {
        label: 'System Settings',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.ace}/${ADMIN_ACE_ROUTES.systemSettings}`,
        claimName: ADMIN_CLAIMS.aceAiSystemSettingsRead,
      },
    ],
  },
  {
    label: 'Integration',
    expanded: true,
    claimGroupName: EClaimsGroup.integration,
    items: [
      {
        label: 'Ad Source Mapping',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.integration}/${ADMIN_INTEGRATION_ROUTES.sourceMapping}`,
        claimName: ADMIN_CLAIMS.adSourceMappingRead,
      },
      {
        label: 'Partner Integration',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.integration}/${ADMIN_INTEGRATION_ROUTES.partnerIntegration}`,
        claimName: ADMIN_CLAIMS.partnerIntegrationRead,
      },
    ],
  },
  {
    label: 'Work Orders',
    expanded: true,
    claimGroupName: EClaimsGroup.workOrders,
    items: [
      {
        label: 'System Settings',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.workOrders}/${ADMIN_WORK_ORDERS_ROUTES.systemSettings}`,
        claimName: ADMIN_CLAIMS.WorkOrdersSystemSettingsRead,
      },
      {
        label: 'Form Settings',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.workOrders}/${ADMIN_WORK_ORDERS_ROUTES.formSettings}`,
        claimName: ADMIN_CLAIMS.WorkOrderFormSettingsRead,
      },
      {
        label: 'Form Styling',
        routerLink: `/${ROOT_ROUTES.admin}/${ADMIN_ROOT_ROUTES.workOrders}/${ADMIN_WORK_ORDERS_ROUTES.formStyling}`,
        claimName: ADMIN_CLAIMS.WorkOrderFormStylingRead,
      },
    ],
  },
];
